






























































import { Component, Vue, Prop } from "vue-property-decorator";
import { User as IUser } from "@/api/models/user";
import { Company as ICompany } from "@/api/models/company";
import CustomTable from "@/components/form/CustomTable.vue";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
import companyList, { CompanyListParams } from "@/getinfo-api/company";
import { CompaniesList as ICompaniesList } from "@/api/models/companies-list";
import UsersListFormItem from "@/components/user/UsersListFormItem.vue";
import CompanyListsFormItem from "@/components/companies/CompanyListsFormItem.vue";

// TODO: Добавить ответственного после реализации этой фичи на беке
@Component({
  components: {
    CompanyListsFormItem,
    UsersListFormItem,
    CustomTableCol,
    CustomTableItem,
    CustomTable
  }
})
export default class getUser extends Vue {
  @Prop() users?: Array<IUser>;
  @Prop() companies?: Array<ICompany>;
  @Prop({ default: false }) isAdminFunctional!: boolean;
  @Prop({ default: false }) sortList!: boolean;
  @Prop({ default: false }) isLoading?: boolean;
  usersCompanies: Array<ICompany> = [];
  sort: boolean = true;

  data() {
    return {
      companiesList: undefined,
      usersList: undefined
    };
  }

  SortCompanyList() {
    this.$emit("sort", this.sort);
    this.sort = !this.sort;
  }

  get screenWidth() {
    return window.innerWidth;
  }

  created() {
    if (this.users) {
      let params: CompanyListParams = {
        employeesIds: this.users.map(el => el.id),
        limit: 999
      };
      companyList(params).then((res: { data: ICompaniesList }) => {
        this.usersCompanies = res.data.companies;
      });
    }
  }
}
